export interface PartnerPage {
  name: string | null;
  text: string | null;
  link: string | null;
  callToAction: string | null;
  logoId: string | null;
  logoUrl: string | null;
  updatedAt: string | null;
  configured: boolean;
}

export interface PartnerPageSaved extends PartnerPage {
  warnings: { field: string; code: string; kinds: string[]; message: string }[];
}

export interface UploadedLogo {
  logoId: string;
  url: string;
  width: number;
  height: number;
}

export const LIMITS = { name: 80, text: 280, callToAction: 40 } as const;
